import { IconSize } from '..'
import { iconSizes } from '../constants'

type Prop = IconSize | undefined

const getIconSize = (iconSize: Prop): number => {
  return iconSizes[iconSize || 'medium']
}
export default getIconSize
